// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relative-div-bg {
  position: relative;
}
.absolute-div-home {
  position: absolute;
  top: 0;
  right: 0;
  height: 300px;
  width: 70% !important;
  /* background-color: red; */
  z-index: -1;
  padding: 0;
}

.absolute-home-div-img {
  position: absolute;
  background-image: var(--bg-green-url);
  top: -50%;
  width: 200px;
  z-index: -1;
  background-repeat: no-repeat;
  height: 400px;
  background-size: cover;
  right: 20%;
  transform: rotate(90deg);
}

.absolute-side-div-img {
  position: absolute;
  background-image: var(--bg-green-url);
  top: 0;
  width: 200px;
  z-index: -1;
  background-repeat: no-repeat;
  height: 400px;
  background-size: cover;
  left: -15%;
}

.bg-home-bottom-div {
  background-color: #f5f5f5;
}

.img-home-bottom {
  max-width: 50%;
  padding: 10px;
  max-height: 80px;
}

.fish-card-div-height {
  min-height: 250px;
}

@media (max-width: 600px) {
  .absolute-side-div-img {
    display: none;
  }
  .absolute-home-div-img {
    display: none;
  }
  .absolute-div-home {
    display: none;
  }
  .img-home-bottom {
    max-width: 75%;
  }
  .img-leaf-home-2,
  .img-leaf-choos {
    height: 40px;
  }
}

.absolute-img-div-leaf-choos {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.img-leaf-choos {
  transform: rotate(260deg) scaleX(-1);
}

.absolute-img-div-leaf-home-2 {
  position: absolute;
  bottom: 10px;
  right: 0;
  z-index: -1;
}

.img-leaf-home-2 {
  transform: rotate(170deg) scaleX(-1);
}

.product-badge-div {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  padding: 2px 8px;
  background-color: #c4f3d0;
  border-top-left-radius: 15px;
  color: #28af4b;
  border-bottom-right-radius: 5px;
  font-family: "Poppins", sans-serif;
  /* border: 0.5px solid #28af4b; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/homepage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,SAAS;EACT,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,MAAM;EACN,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;AACnC","sourcesContent":[".relative-div-bg {\n  position: relative;\n}\n.absolute-div-home {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 300px;\n  width: 70% !important;\n  /* background-color: red; */\n  z-index: -1;\n  padding: 0;\n}\n\n.absolute-home-div-img {\n  position: absolute;\n  background-image: var(--bg-green-url);\n  top: -50%;\n  width: 200px;\n  z-index: -1;\n  background-repeat: no-repeat;\n  height: 400px;\n  background-size: cover;\n  right: 20%;\n  transform: rotate(90deg);\n}\n\n.absolute-side-div-img {\n  position: absolute;\n  background-image: var(--bg-green-url);\n  top: 0;\n  width: 200px;\n  z-index: -1;\n  background-repeat: no-repeat;\n  height: 400px;\n  background-size: cover;\n  left: -15%;\n}\n\n.bg-home-bottom-div {\n  background-color: #f5f5f5;\n}\n\n.img-home-bottom {\n  max-width: 50%;\n  padding: 10px;\n  max-height: 80px;\n}\n\n.fish-card-div-height {\n  min-height: 250px;\n}\n\n@media (max-width: 600px) {\n  .absolute-side-div-img {\n    display: none;\n  }\n  .absolute-home-div-img {\n    display: none;\n  }\n  .absolute-div-home {\n    display: none;\n  }\n  .img-home-bottom {\n    max-width: 75%;\n  }\n  .img-leaf-home-2,\n  .img-leaf-choos {\n    height: 40px;\n  }\n}\n\n.absolute-img-div-leaf-choos {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.img-leaf-choos {\n  transform: rotate(260deg) scaleX(-1);\n}\n\n.absolute-img-div-leaf-home-2 {\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  z-index: -1;\n}\n\n.img-leaf-home-2 {\n  transform: rotate(170deg) scaleX(-1);\n}\n\n.product-badge-div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 12px;\n  padding: 2px 8px;\n  background-color: #c4f3d0;\n  border-top-left-radius: 15px;\n  color: #28af4b;\n  border-bottom-right-radius: 5px;\n  font-family: \"Poppins\", sans-serif;\n  /* border: 0.5px solid #28af4b; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
